import React from 'react';
import 'firebase/auth';
import 'firebase/firestore';

export const FirebaseContext = React.createContext();
export const FirebaseProvider = FirebaseContext.Provider;
export const FirebaseConsumer = FirebaseContext.Consumer;